import React from "react";
import PropTypes from "prop-types";
import styles from "./FilterMenu.module.css";
import FilterItem from "../FilterItem";

export function FilterMenu({
  filters = [],
  selectedFilters = {},
  onChange = () => {},
  filterModes = {},
  onModeChange,
  onClearGroup,
  onResetAll,
}) {
  if (!filters.length) {
    return null;
  }

  return (
    <div className={styles.menu}>
      {typeof onResetAll === "function" && (
        <button
          type="button"
          className={styles.clearAll}
          onClick={() => onResetAll()}
          title="Clear all selected filters."
        >
          Reset filters
        </button>
      )}
      {filters.map(
        ({
          title,
          key,
          options = [],
          allowCustom = false,
          multi = false,
          clearable = false,
        }) => (
          <div className={styles.group} key={key}>
            <FilterItem
              title={title}
              options={options}
              selected={selectedFilters[key] || []}
              onChange={(option, checked) => onChange(key, option, checked)}
              allowCustom={allowCustom}
              matchMode={multi ? filterModes[key] || "AND" : undefined}
              onMatchModeChange={
                multi && typeof onModeChange === "function"
                  ? (mode) => onModeChange(key, mode)
                  : undefined
              }
              onClear={
                clearable && typeof onClearGroup === "function"
                  ? () => onClearGroup(key)
                  : undefined
              }
            />
          </div>
        )
      )}
    </div>
  );
}

FilterMenu.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
      options: PropTypes.array.isRequired,
      allowCustom: PropTypes.bool,
      multi: PropTypes.bool,
      clearable: PropTypes.bool,
    })
  ),
  selectedFilters: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  onChange: PropTypes.func,
  filterModes: PropTypes.objectOf(PropTypes.string),
  onModeChange: PropTypes.func,
  onClearGroup: PropTypes.func,
  onResetAll: PropTypes.func,
};
